export function Share(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Icon / Share">
          <path
            id="Icon"
            d="M36 18C39.3137 18 42 15.3137 42 12C42 8.68629 39.3137 6 36 6C32.6863 6 30 8.68629 30 12C30 12.1049 30.0027 12.2091 30.008 12.3127L15.8454 19.394C14.8041 18.5238 13.4632 18 12 18C8.68629 18 6 20.6863 6 24C6 27.3137 8.68629 30 12 30C13.4632 30 14.8041 29.4762 15.8454 28.606L30.008 35.6873C30.0027 35.7909 30 35.8951 30 36C30 39.3137 32.6863 42 36 42C39.3137 42 42 39.3137 42 36C42 32.6863 39.3137 30 36 30C34.5368 30 33.1959 30.5238 32.1546 31.3941L17.992 24.313C17.9973 24.2093 18 24.105 18 24C18 23.895 17.9973 23.7907 17.992 23.687L32.1546 16.6059C33.1959 17.4762 34.5368 18 36 18Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </div>
  );
}
